/* eslint-disable no-confusing-arrow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable operator-linebreak */
import React, { useCallback, useEffect, useRef, useState, useContext, useLayoutEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Col,
  Row,
  Container,
  Form,
  Button,
  Label,
  FormGroup,
  Input,
  FormFeedback,
} from 'reactstrap';

import { yupResolver } from '@hookform/resolvers/yup';
import cn from 'classnames';
import { addHours, format, getDate, getHours, getMinutes, getMonth, getYear, parseISO, differenceInSeconds } from 'date-fns';

import AlertModal from "../../components/AlertModal";
import CustomSelectSearch from '../../components/CustomSelectSearch';
import DateTimePickerInput from '../../components/DateTimePickerInput';
// import CustomSelect from '../../components/CustomSelect';
// import TimePickerMaskedInput from '../../components/TimePickerMaskedInput';
import { AppContext } from '../../contexts/app';
import useApp from '../../hooks/useApp';
import useAuth from '../../hooks/useAuth';
import useGenerateIntervalHours from '../../hooks/useGenerateIntervalHours';
import useSecondsToDhms from '../../hooks/useSecondsToDhms';
import api from '../../services/api';
import { numberToCurrency } from '../../utils/functions';
import { schema } from './validationSchema';

function Agendamento() {
  const alertModalRef = useRef();
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setLoading, notificationRef } = useApp();
  const { loggedUser } = useAuth();
  const { generateIntervalHours } = useGenerateIntervalHours();
  const { convertSecondsToDhms } = useSecondsToDhms();
  const [includeTimes, setIncludeTimes] = useState([]);
  const [salasAtendimentos, setSalasAtendimentos] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [loadingClientes, setLoadingClientes] = useState(false);
  const [loadingParticipantes, setLoadingParticipantes] = useState(false);
  const [loadingPreviewValue, setLoadingPreviewValue] = useState(false);
  // const [dataHoraInicioInputType, setDataHoraInicioInputType] = useState("select");
  const [daysOfCalendar, setDaysOfCalendar] = useState([]);
  const [disponibilidades, setDisponibilidades] = useState([]);
  const [isPreAgendamento, setIsPreAgendamento] = useState(false);
  const [isAberto, setIsAberto] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockedMessage, setBlockedMessage] = useState('');
  const [previewValue, setPreviewValue] = useState(0);
  const [previewHours, setPreviewHours] = useState(0);
  const { control, watch, setValue, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      salaAtendimento: '',
      especialidade: '',
      status: 'aberto',
      dataHoraInicio: '',
      dataHoraTermino: '',
      repetir: 'padrao',
      dataRepetirTermino: '',
      participantes: [],
      cliente: '',
      observacoes: '',
    },
    resolver: yupResolver(schema)
  });
  const watchSalaAtendimento = watch('salaAtendimento');
  const watchDataAtendimento = watch('dataAtendimento');
  const watchEspecialidade = watch('especialidade');
  const watchCliente = watch('cliente');
  const watchRepetir = watch('repetir');
  const watchDataHoraInicio = watch('dataHoraInicio');
  const watchDataHoraTermino = watch('dataHoraTermino');
  const { setHeaderTitle } = useContext(AppContext);

  useLayoutEffect(() => {
    setHeaderTitle('Atendimento');
  }, [setHeaderTitle]);

  useEffect(() => {
    (async () => {
      try {
        const { data = [] } = await api.get('/salaAtendimentos?limit=0');
        setSalasAtendimentos(data.map((d) => ({
          value: d._id,
          label: d.nome,
        })));
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const especialidade = watchEspecialidade;
        if (especialidade) {
          setLoadingClientes(true);
          const { data = [] } = await api.get(`/profissionalClientes?tipoDeAtendimento=${especialidade}`);
          // console.log(data);
          setClientes(data.map((d) => ({
            value: d._id,
            cpf: d.criancas.cpf,
            label: d.criancas.nome,
            adminFaturamento: d.adminFaturamento,
          })));
          setLoadingClientes(false);
        }
      } catch (error) {
        setLoadingClientes(false);
        console.log(error);
      }
    })();
  }, [watchEspecialidade]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingParticipantes(true);
        const { data = [] } = await api.get(`/profissionalParticipantes`);
        setParticipantes(data.map((d) => ({
          value: d.id,
          label: `${d.name} (${d.type})`,
          type: d.type,
        })));
        setLoadingParticipantes(false);
      } catch (error) {
        setLoadingParticipantes(false);
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    const salaAtendimento = watchSalaAtendimento;
    console.log('🚀 ~ useEffect ~ salaAtendimento:', salaAtendimento);
    if (salaAtendimento) {
      (async () => {
        try {
          setLoading(true);
          const firstDayOfCalendar = daysOfCalendar[0];
          const lastDayOfCalendar = daysOfCalendar[daysOfCalendar.length - 1];

          // console.log(firstDayOfCalendar, lastDayOfCalendar);
          if (firstDayOfCalendar && lastDayOfCalendar) {
            const { data = [] } = await api.get(`/salaAtendimentoDisponibilidades/${salaAtendimento}?dataHoraInicio=${firstDayOfCalendar}&dataHoraTermino=${lastDayOfCalendar}`);
            // console.log(data);
            setDisponibilidades(data.map((d) => ({ ...d, startDate: d.dataHoraInicio, endDate: d.dataHoraTermino })));
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      })();
    }
  }, [daysOfCalendar, watchSalaAtendimento]);

  const getIncludeTimes = useCallback((date) => {
    setIncludeTimes([]);
    if (disponibilidades?.length && date) {
      /* console.log('disponibilidade', date, disponibilidades.find((d) => getDate(new Date(d.startDate)) === getDate(date)
        && getMonth(new Date(d.startDate)) === getMonth(date)
        && getYear(new Date(d.startDate)) === getYear(date))); */
      const disponibilidadesFiltered = disponibilidades.filter((d) => getDate(new Date(d.startDate)) === getDate(date)
        && getMonth(new Date(d.startDate)) === getMonth(date)
        && getYear(new Date(d.startDate)) === getYear(date));
      // console.log('🚀 ~ file: index.js:109 ~ useEffect ~ disponibilidadesFiltered:', disponibilidadesFiltered);

      if (disponibilidadesFiltered?.length) {
        const avaibilitiesTimes = [];
        for (const disponibilidade of disponibilidadesFiltered) {
          avaibilitiesTimes.push(...generateIntervalHours(new Date(disponibilidade.startDate), getHours(new Date(disponibilidade.startDate)), getHours(new Date(disponibilidade.endDate)), getMinutes(new Date(disponibilidade.startDate)), getMinutes(new Date(disponibilidade.endDate))));
        }
        setIncludeTimes(avaibilitiesTimes);
      }
    }
  }, [disponibilidades?.length]);

  useEffect(() => {
    if (disponibilidades?.length && watchDataAtendimento) {
      getIncludeTimes(watchDataAtendimento);
    }
  }, [watchDataAtendimento, disponibilidades?.length, getIncludeTimes]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/getEspecialistas');
        setEspecialidades(data.especialidades.map((e) => ({
          value: e._id,
          label: e.nome,
          cor: e.cor,
        })));
      } catch (error) {
        console.log("🚀 ~ error:", error);
      }
    })();
  }, []);

  useEffect(() => {
    setValue('dataHoraInicio', '');
    setValue('dataHoraTermino', '');
  }, [watchDataAtendimento]);

  useEffect(() => {
    setIsPreAgendamento(false);
    setIsBlocked(false);
    setBlockedMessage('');
    console.log("🚀 ~ useEffect ~ params?.data:", searchParams.get('data'));
    if (searchParams.get('data')) {
      const queryDate = new Date(searchParams.get('data'));
      setValue('dataAtendimento', queryDate);
      getIncludeTimes(queryDate);
    }
    if (params?.id) {
      (async () => {
        try {
          setLoading(true);
          const { data } = await api.get(`/profissionalAgendamentos/${params.id}`);

          setValue('salaAtendimento', data?.salaAtendimento?._id ? data?.salaAtendimento?._id : '');
          setValue('especialidade', data?.especialidade?._id ? data.especialidade._id : '');
          setValue('cliente', data?.cliente?.id ? data.cliente.id : '');
          setValue('participantes', data?.participantes?.map((p) => p.id) || []);
          setValue('dataAtendimento', data?.dataHoraInicio ? parseISO(data.dataHoraInicio) : null);
          setValue('dataHoraInicio', data?.dataHoraInicio ? format(parseISO(data.dataHoraInicio), 'HH:mm') : '');
          setValue('dataHoraTermino', data?.dataHoraTermino ? format(parseISO(data.dataHoraTermino), 'HH:mm') : '');
          setValue('dataRepetirTermino', data?.dataRepetirTermino ? parseISO(data.dataRepetirTermino) : null);
          setValue('repetir', data?.repetir || 'padrao');
          setValue('observacoes', data?.observacoes || '');
          setIsPreAgendamento(data?.preAgendamento);
          setIsAberto(data?.status === 'aberto');
          setIsBlocked(!!data?.isBlocked);
          setBlockedMessage(data?.message || '');
          setLoading(false);

          if (data?.isBlocked) {
            alertModalRef.current.show({
              title: 'Aviso',
              message:
                data.message ||
                'Este período está fechado. Procure o administrador para qualquer ajuste.',
              confirmText: 'Ok',
              confirmColor: 'warning',
              hideCancel: true,
              onConfirm: () => {
                alertModalRef.current.close();
                navigate('/agenda');
              },
            });
          }
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      })();
    }
  }, [params]);

  const onDataHoraInicioChange = useCallback(({ event, onChange, value, newValue }) => {
    event.target.value = newValue;
    onChange(event);
    console.log('🚀 ~ useEffect ~ watchDataAtendimento:', watchDataAtendimento);
    console.log('🚀 ~ useEffect ~ dataHoraInicio:', value);
    try {
      if (value && watchDataAtendimento) {
        const hourToAdd = value.includes('+') ? Number(value.split('+')[1]) : 1;
        const normalizedDataHoraInicio = value.includes('+') ? value.split('+')[0] : value;
        console.log("🚀 ~ useEffect ~ hourToAdd:", hourToAdd);
        const dataHoraInicioAddedHour = typeof normalizedDataHoraInicio === 'string'
          ? addHours(new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(`${normalizedDataHoraInicio}`.split(':')[0]), Number(`${normalizedDataHoraInicio}`.split(':')[1])), hourToAdd)
          : addHours(normalizedDataHoraInicio, hourToAdd);
        console.log('🚀 ~ useEffect ~ dataHoraInicioAddedHour:', dataHoraInicioAddedHour);
        setValue('dataHoraTermino', format(dataHoraInicioAddedHour, 'HH:mm'));
      }
    } catch (error) {
      console.log('🚀 ~ useEffect ~ error:', error);
    }
  }, [watchDataAtendimento]);

  const onCalculatePreviewHours = useCallback(() => {
    setPreviewHours('');
    if (watchDataHoraInicio && watchDataHoraTermino && watchDataHoraInicio.match(/^\d{2}:\d{2}$/) && watchDataHoraTermino.match(/^\d{2}:\d{2}$/)) {
      const normalizedDataHoraInicio = watchDataHoraInicio.includes('+') ? watchDataHoraInicio.split('+')[0] : watchDataHoraInicio;
      const dataHoraInicio = new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(normalizedDataHoraInicio.split(':')[0]), Number(normalizedDataHoraInicio.split(':')[1]));
      const dataHoraTermino = new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(watchDataHoraTermino.split(':')[0]), Number(watchDataHoraTermino.split(':')[1]));
      const diffInSeconds = differenceInSeconds(dataHoraTermino, dataHoraInicio);
      setPreviewHours(convertSecondsToDhms(diffInSeconds));
    }
  }, [watchDataHoraInicio, watchDataHoraTermino, watchDataAtendimento]);

  useEffect(() => {
    onCalculatePreviewHours();
  }, [watchDataHoraInicio, watchDataHoraTermino, watchDataAtendimento]);

  // endpoint para calcular o valor do atendimento: /profissionais/previewValorAgendamento
  const onCalculatePreviewValue = useCallback(() => {
    (async () => {
      try {
        setLoadingPreviewValue(true);
        setPreviewValue(0);
        if (watchDataHoraInicio && watchDataHoraTermino && watchDataAtendimento && watchEspecialidade && watchDataHoraInicio.match(/^\d{2}:\d{2}$/) && watchDataHoraTermino.match(/^\d{2}:\d{2}$/)) {
          const normalizedDataHoraInicio = watchDataHoraInicio.includes('+') ? watchDataHoraInicio.split('+')[0] : watchDataHoraInicio;
          const dataHoraInicio = new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(normalizedDataHoraInicio.split(':')[0]), Number(normalizedDataHoraInicio.split(':')[1]));
          const dataHoraTermino = new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(watchDataHoraTermino.split(':')[0]), Number(watchDataHoraTermino.split(':')[1]));
          const { data } = await api.get(`/profissionais/previewValorAgendamento?dataHoraInicio=${dataHoraInicio}&dataHoraTermino=${dataHoraTermino}&especialidadeId=${watchEspecialidade}`);
          console.log('🚀 ~ onCalculatePreviewValue ~ data:', data);
          setPreviewValue(data.valor);
        }
        setLoadingPreviewValue(false);
      } catch (err) {
        console.log('🚀 ~ onCalculatePreviewValue ~ error:', err);
        setLoadingPreviewValue(false);
        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao realizar Agendamento',
          color: 'danger',
        });
      }
    })();
  }, [watchDataHoraInicio, watchDataHoraTermino, watchEspecialidade, watchDataAtendimento]);

  useEffect(() => {
    if (watchDataHoraInicio && watchDataHoraTermino && watchDataAtendimento && watchEspecialidade) {
      onCalculatePreviewValue();
    }
  }, [watchDataHoraInicio, watchDataHoraTermino, watchDataAtendimento, watchEspecialidade]);

  const onSubmit = (formValues) => {
    console.log(formValues);

    if (params?.id && isBlocked) {
      alertModalRef.current.show({
        title: 'Aviso',
        message:
          blockedMessage ||
          'Este período está fechado. Procure o administrador para qualquer ajuste.',
        confirmText: 'Ok',
        confirmColor: 'warning',
        hideCancel: true,
        onConfirm: () => {
          alertModalRef.current.close();
        },
      });
      return;
    }

    const normalizedDataHoraInicio = formValues.dataHoraInicio.includes('+') ? formValues.dataHoraInicio.split('+')[0] : formValues.dataHoraInicio;
    (async () => {
      try {
        setLoading(true);
        const _cliente = clientes.find((c) => c.value === formValues.cliente);
        const recorrente = searchParams.get('recorrente');
        const data = {
          cliente: {
            id: _cliente.value,
            cpf: _cliente.cpf,
            nome: _cliente.label,
          },
          participantes: participantes.filter((p) => formValues.participantes?.includes(p.value)).map((p) => ({
            id: p.value,
            name: p.label,
            type: p.type,
          })),
          profissional: loggedUser._id,
          salaAtendimento: formValues.salaAtendimento,
          especialidade: formValues.especialidade,
          dataHoraInicio: new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(normalizedDataHoraInicio.split(':')[0]), Number(normalizedDataHoraInicio.split(':')[1])),
          dataHoraTermino: new Date(getYear(watchDataAtendimento), getMonth(watchDataAtendimento), getDate(watchDataAtendimento), Number(formValues.dataHoraTermino.split(':')[0]), Number(formValues.dataHoraTermino.split(':')[1])),
          dataRepetirTermino: formValues.dataRepetirTermino,
          repetir: formValues.repetir,
          observacoes: formValues.observacoes,
          updateIsRecorrente: recorrente === "true",
        };
        console.log('🚀 ~ data:', data);

        if (params?.id) {
          await api.put(`/profissionalAgendamentos/${params.id}`, data);
          /* setTimeout(() => {
            navigate('/');
          }, 1000); */
          setTimeout(() => {
            setLoading(false);
            notificationRef.current.notify({
              message: 'Agendamento atualizado com sucesso',
            });
            navigate(`/agenda`);
          }, 500);
          return;
        }

        const { data: newAgendamento } = await api.post('/profissionalAgendamentos', data);

        /* setTimeout(() => {
          navigate(`/agendamento/${newAgendamento._id}`);
        }, 1000); */
        setTimeout(() => {
          setLoading(false);
          notificationRef.current.notify({
            message: 'Agendamento realizado com sucesso',
          });
          navigate(`/agenda`);
        }, 500);
      } catch (err) {
        console.log('🚀 ~ err:', err);
        setLoading(false);
        if (err && err.response && err.response.data) {
          const { message } = err.response.data;

          if (message) {
            notificationRef.current.notify({
              message,
              color: 'danger',
            });

            return;
          }
        }

        notificationRef.current.notify({
          message: 'Falha ao realizar Agendamento',
          color: 'danger',
        });
      }
    })();
  };

  return (
    <Container fluid>
      <AlertModal ref={alertModalRef} />
      <Row>
        <Col>
          <Row className="mt-2">
            <Col>
              <div className="d-flex justify-content-center">
                <Form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%', maxWidth: '1024px' }} className="bg-primary p-4 rounded">
                  {/* <CustomSelect
                    label="Sala de Atendimento"
                    placeholder="Selecione uma Sala de Atendimento"
                    invalidMessage={errors?.salaAtendimento?.value?.message}
                    {...field}
                    options={salasAtendimentos}
                  /> */}
                  <Controller
                    id="salaAtendimentoSelect"
                    name="salaAtendimento"
                    control={control}
                    render={({ field: { onChange, name, value } }) => (
                      <FormGroup>
                        <Label for="salaAtendimentoSelect">
                          Sala de Atendimento
                        </Label>
                        <Input
                          id="salaAtendimentoSelect"
                          type="select"
                          name={name}
                          value={value}
                          onChange={onChange}
                          invalid={!!errors?.salaAtendimento?.message}
                          onFocus={(e) => {
                            console.log("🚀 ~ Agendamento ~ salaAtendimento ~ e:", e, document.activeElement.id);
                          }}
                        >
                          <option value="">Selecione uma Sala de Atendimento</option>
                          {salasAtendimentos.map((sala) => (
                            <option key={sala.value} value={sala.value}>
                              {sala.label}
                            </option>
                          ))}
                        </Input>
                        <FormFeedback>{errors?.salaAtendimento?.message}</FormFeedback>
                      </FormGroup>
                    )}
                  />
                  <Controller
                    name="dataAtendimento"
                    control={control}
                    render={({ field }) => (
                      <DateTimePickerInput
                        label="Data do Atendimento"
                        invalidMessage={errors?.dataAtendimento?.message}
                        events={disponibilidades}
                        onDaysOfCalendarChange={(dates) => setDaysOfCalendar(dates)}
                        onChange={(e) => field.onChange(e)}
                        selected={field.value}
                        showTimeInput={false}
                      />
                    )}
                  />
                  <Controller
                    name="especialidade"
                    control={control}
                    render={({ field: { onChange, name, value } }) => (
                      <FormGroup>
                        <Label for="especialidadeSelect">
                          Tipo de Atendimento
                        </Label>
                        <CustomSelectSearch
                          id="especialidadeSelect"
                          name={name}
                          value={value}
                          onChange={onChange}
                          options={especialidades}
                          placeholder="Selecione um Tipo de Atendimento"
                          invalid={!!errors?.especialidade?.message}
                          errorMessage={errors?.especialidade?.message}
                          loadingMessage="Carregando tipos de atendimento"
                          noOptionsMessage="Nenhum tipo de atendimento encontrado"
                          onRenderLabel={(option) => (
                            <div className="d-flex align-items-center">
                              <div style={{ backgroundColor: option.cor, width: '20px', height: '20px', borderRadius: '10px', marginRight: '0.5rem' }} />
                              {option.label}
                            </div>
                          )}
                        />
                      </FormGroup>
                    )}
                  />
                  <Controller
                    name="cliente"
                    control={control}
                    render={({ field: { onChange, name, value } }) => (
                      <FormGroup>
                        <Label for="clienteSelect">
                          Cliente
                        </Label>
                        <CustomSelectSearch
                          id="clienteSelect"
                          name={name}
                          value={value}
                          onChange={onChange}
                          options={clientes}
                          placeholder="Selecione um Cliente"
                          invalid={!!errors?.cliente?.message}
                          errorMessage={errors?.cliente?.message}
                          isLoading={loadingClientes}
                          loadingMessage="Carregando clientes de acordo com o tipo de atendimento selecionado"
                          noOptionsMessage={
                            !clientes.length && watchEspecialidade
                              ? 'Nenhum cliente encontrado de acordo com o tipo de atendimento selecionado'
                              : 'Selecione um tipo de atendimento'
                          }
                        />
                      </FormGroup>
                    )}
                  />
                  <FormGroup>
                    <Label for="adminFaturamento">
                      Responsável Faturamento
                    </Label>
                    <Input
                      id="adminFaturamento"
                      type="text"
                      name="adminFaturamento"
                      value={clientes.find((c) => c.value === watchCliente)?.adminFaturamento || ''}
                      readOnly
                    />
                  </FormGroup>
                  {/* <Row>
                    <Col>
                      <Button onClick={() => setDataHoraInicioInputType((prev) => prev === 'select' ? 'time' : 'select')}>
                        {dataHoraInicioInputType === 'select' ? 'Digitar Hora' : 'Selecionar Hora'}
                      </Button>
                    </Col>
                  </Row> */}
                  <Row>
                    <Col xs={12} sm={6}>
                      {/* <TimePickerMaskedInput
                          label="Hora de início do atendimento"
                          date={watchDataAtendimento}
                          invalidMessage={errors?.dataHoraInicio?.message}
                          onChange={(e) => field.onChange(e)}
                          selected={field.value}
                          includeTimes={includeTimes}
                        /> */}
                      <Controller
                        name="dataHoraInicio"
                        control={control}
                        render={({ field: { onChange, name, value } }) => {
                          const handleTimeInput = (e) => {
                            const currentValue = e.target.value;
                            let newValue = e.target.value.replace(/\D/g, ""); // remove tudo que não for dígito
                            // Se tiver mais de 2 dígitos, insere ':'
                            if (newValue.length > 2) {
                              newValue = `${newValue.slice(0, 2)}:${newValue.slice(2)}`;
                            }
                            // Limita a 5 caracteres (HH:MM)
                            if (newValue.length > 5) {
                              newValue = newValue.slice(0, 5);
                            }
                            onDataHoraInicioChange({ event: e, onChange, value: currentValue, newValue });
                          };

                          return (
                            <FormGroup>
                              <Label for="dataHoraInicioSelect">Hora de início do atendimento</Label>
                              <div className="position-relative d-flex align-items-center">
                                <Input
                                  id="dataHoraInicioSelect"
                                  type="text"
                                  list="horariosPermitidos"
                                  placeholder="HH:MM"
                                  maxLength={7}
                                  name={name}
                                  value={value}
                                  onChange={handleTimeInput}
                                  invalid={!!errors?.dataHoraInicio?.message}
                                  onClick={(e) => {
                                    if (!watchSalaAtendimento) {
                                      alertModalRef.current.show({
                                        title: 'Atenção',
                                        message: 'Selecione uma sala de atendimento para poder definir a hora de início do atendimento',
                                        confirmText: 'OK',
                                        confirmColor: 'primary',
                                        hideCancel: true,
                                        onConfirm: () => {
                                          alertModalRef.current.close();
                                        },
                                      });
                                    }
                                  }}
                                  style={{ marginRight: '8px' }}
                                />
                                <Button
                                  type="button"
                                  className="position-absolute p-2 text-black bg-primary border-0"
                                  style={{ height: '1.6rem', right: '-0.75rem' }}
                                  color="link"
                                  onClick={() => {
                                    const eventFake = { target: { value: '' } };
                                    handleTimeInput(eventFake);
                                  }}
                                >
                                  <i className="fa fa-xmark" />
                                </Button>
                              </div>
                              <datalist id="horariosPermitidos">
                                {includeTimes.map((time, index) => (
                                  <option
                                    key={`${time}-${index}`}
                                    value={format(time, 'HH:mm')}
                                  >
                                    {format(time, 'HH:mm')}
                                  </option>
                                ))}
                                {watchSalaAtendimento && includeTimes?.length && (
                                  <>
                                    <option value="08:00+4">08:00 - 12:00 (4h MANHÃ)</option>
                                    <option value="09:00+4">09:00 - 13:00 (4h MANHÃ)</option>
                                    <option value="13:00+4">13:00 - 17:00 (4h TARDE)</option>
                                    <option value="14:00+4">14:00 - 18:00 (4h TARDE)</option>
                                    <option value="09:00+8">09:00 - 17:00 (8h DIA)</option>
                                    <option value="10:00+8">10:00 - 18:00 (8h DIA)</option>
                                  </>
                                )}
                              </datalist>
                              <FormFeedback>{errors?.dataHoraInicio?.message}</FormFeedback>
                            </FormGroup>
                          );
                        }}
                      />
                    </Col>
                    {/* <TimePickerMaskedInput
                      label="Hora de término do atendimento"
                      date={watchDataAtendimento}
                      invalidMessage={errors?.dataHoraTermino?.message}
                      onChange={(e) => field.onChange(e)}
                      selected={field.value}
                      includeTimes={includeTimes}
                    /> */}
                    <Col xs={12} sm={6}>
                      <Controller
                        name="dataHoraTermino"
                        control={control}
                        render={({ field: { onChange, name, value } }) => {
                          const handleTimeInput = (e) => {
                            let newValue = e.target.value.replace(/\D/g, ""); // remove tudo que não for dígito
                            // Se tiver mais de 2 dígitos, insere ':'
                            if (newValue.length > 2) {
                              newValue = `${newValue.slice(0, 2)}:${newValue.slice(2)}`;
                            }
                            // Limita a 5 caracteres (HH:MM)
                            if (newValue.length > 5) {
                              newValue = newValue.slice(0, 5);
                            }
                            e.target.value = newValue;
                            onChange(e);
                          };

                          return (
                            <FormGroup>
                              <Label for="dataHoraTerminoSelect">Hora de término do atendimento</Label>
                              <div className="position-relative d-flex align-items-center">
                                <Input
                                  id="dataHoraTerminoSelect"
                                  type="text"
                                  list="horariosPermitidosDataHoraTermino"
                                  placeholder="HH:MM"
                                  maxLength={5}
                                  name={name}
                                  value={value}
                                  onChange={handleTimeInput}
                                  invalid={!!errors?.dataHoraTermino?.message}
                                  onClick={(e) => {
                                    // console.log("🚀 ~ Agendamento ~ e:", e, document.activeElement.id);
                                    if (!watchSalaAtendimento) {
                                      alertModalRef.current.show({
                                        title: 'Atenção',
                                        message: 'Selecione uma sala de atendimento para poder definir a hora de término do atendimento',
                                        confirmText: 'OK',
                                        confirmColor: 'primary',
                                        hideCancel: true,
                                        onConfirm: () => {
                                          alertModalRef.current.close();
                                        },
                                      });
                                    }
                                  }}
                                  style={{ marginRight: '8px' }}
                                />
                                <Button
                                  type="button"
                                  className="position-absolute p-2 text-black bg-primary border-0"
                                  style={{ height: '1.6rem', right: '-0.75rem' }}
                                  color="link"
                                  onClick={() => {
                                    const eventFake = { target: { value: '' } };
                                    handleTimeInput(eventFake);
                                  }}
                                >
                                  <i className="fa fa-xmark" />
                                </Button>
                              </div>
                              <datalist id="horariosPermitidosDataHoraTermino">
                                {includeTimes.map((time, index) => (
                                  <option
                                    key={`${time}-${index}`}
                                    value={format(time, 'HH:mm')}
                                  >
                                    {format(time, 'HH:mm')}
                                  </option>
                                ))}
                              </datalist>
                              <FormFeedback>{errors?.dataHoraTermino?.message}</FormFeedback>
                            </FormGroup>
                          );
                        }}
                      />
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label for="preview-horas">
                      Prévia de qtde de horas
                    </Label>
                    <Input
                      id="preview-horas"
                      type="text"
                      name="preview-horas"
                      value={previewHours || ''}
                      readOnly
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="preview-valor">
                      Prévia do Valor
                    </Label>
                    <Input
                      id="preview-valor"
                      type="text"
                      name="preview-valor"
                      value={loadingPreviewValue ? 'Calculando Prévia do Valor...' : numberToCurrency(previewValue || 0)}
                      readOnly
                    />
                  </FormGroup>
                  {/* <CustomSelect
                    label="Tipo de Atendimento"
                    text="Selecione um do(s) seu(s) tipo(s) de atendimento para atender o paciente"
                    placeholder="Selecione um tipo de atendimento"
                    invalidMessage={errors?.especialidade?.value?.message}
                    {...field}
                    options={especialidades}
                  /> */}
                  {/* <CustomSelect
                    label="Paciente"
                    placeholder="Selecione um Paciente"
                    loading={loadingClientes}
                    loadingMessage={() => 'Carregando pacientes de acordo com o tipo de atendimento selecionado'}
                    noOptionsMessage={() => (!clientes.length && watchEspecialidade
                      ? 'Nenhum paciente encontrado de acordo com o tipo de atendimento selecionado'
                      : 'Selecione um tipo de atendimento')}
                    invalidMessage={errors?.cliente?.value?.message}
                    {...field}
                    options={clientes}
                  /> */}
                  {(!params?.id || (!isPreAgendamento && isAberto && searchParams.get('recorrente') === "true")) && (
                    <>
                      <Controller
                        name="repetir"
                        control={control}
                        render={({ field: { onChange, name, value } }) => (
                          <FormGroup tag="fieldset">
                            <Label>
                              Repetir Atendimento
                            </Label>
                            <FormGroup check>
                              <Input
                                name={name}
                                type="radio"
                                value="padrao"
                                checked={value === 'padrao'}
                                onChange={onChange}
                              />
                              {' '}
                              <Label check>
                                Não Repetir
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Input
                                name={name}
                                type="radio"
                                value="diario"
                                checked={value === 'diario'}
                                onChange={onChange}
                              />
                              {' '}
                              <Label check>
                                Diariamente
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Input
                                name={name}
                                type="radio"
                                value="semanal"
                                checked={value === 'semanal'}
                                onChange={onChange}
                              />
                              {' '}
                              <Label check>
                                Semanalmente
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Input
                                name={name}
                                type="radio"
                                value="quinzenal"
                                checked={value === 'quinzenal'}
                                onChange={onChange}
                              />
                              {' '}
                              <Label check>
                                Quinzenalmente
                              </Label>
                            </FormGroup>
                            <FormGroup check>
                              <Input
                                name={name}
                                type="radio"
                                value="mensal"
                                checked={value === 'mensal'}
                                onChange={onChange}
                              />
                              {' '}
                              <Label check>
                                Mensalmente
                              </Label>
                            </FormGroup>
                          </FormGroup>
                        )}
                      />
                      {watchRepetir !== 'padrao' && (
                        <Controller
                          name="dataRepetirTermino"
                          control={control}
                          render={({ field: { onChange, name, value } }) => (
                            <DateTimePickerInput
                              label="Data de término da repetição"
                              invalidMessage={errors?.dataRepetirTermino?.message}
                              onChange={(e) => onChange(e)}
                              selected={value}
                              showTimeInput={false}
                            />
                          )}
                        />
                      )}
                    </>
                  )}
                  <Controller
                    name="observacoes"
                    control={control}
                    render={({ field: { onChange, name, value } }) => (
                      <FormGroup>
                        <Label for="observacoes">
                          Observações (
                          {value?.length || 0}
                          /300)
                        </Label>
                        <Input
                          id="observacoes"
                          type="textarea"
                          name={name}
                          value={value}
                          onChange={(e) => {
                            // Limita a 300 caracteres
                            const newValue = e?.target?.value?.slice(0, 300)?.toUpperCase();
                            onChange({
                              ...e,
                              target: {
                                ...e.target,
                                value: newValue,
                              },
                            });
                          }}
                          invalid={!!errors?.observacoes?.message}
                        />
                        <FormFeedback>{errors?.observacoes?.message}</FormFeedback>
                      </FormGroup>
                    )}
                  />
                  <Controller
                    name="participantes"
                    control={control}
                    render={({ field: { onChange, name, value } }) => (
                      <FormGroup>
                        <Label for="participantesSelect">
                          Convidar Participantes (Campo não obrigatório e a notificação no sistema não substitui o convite formal. Envie também por e-mail ou WhatsApp)
                        </Label>
                        <CustomSelectSearch
                          id="participantesSelect"
                          name={name}
                          value={value}
                          onChange={onChange}
                          options={participantes}
                          placeholder="Selecione um ou mais Participantes"
                          invalid={!!errors?.participantes?.message}
                          errorMessage={errors?.participantes?.message}
                          isLoading={loadingParticipantes}
                          loadingMessage="Carregando participantes"
                          noOptionsMessage="Nenhum participante encontrado"
                          isMultiple
                        />
                      </FormGroup>
                    )}
                  />
                  <Button type="submit" className="my-4" color="success" block disabled={!!(params?.id && isBlocked)}>
                    {params?.id ? 'Alterar Agendamento' : 'Agendar'}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Agendamento;
